import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/169.png'


const _withScopeId = n => (_pushScopeId("data-v-de8454f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default" }
const _hoisted_2 = {
  key: 0,
  class: "live-main"
}
const _hoisted_3 = { class: "video-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = {
  key: 0,
  ref: "video",
  id: "video"
}
const _hoisted_6 = {
  key: 1,
  class: "mask"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "toolbar" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-zongrenshu" }, null, -1))
const _hoisted_14 = { class: "links" }
const _hoisted_15 = {
  key: 0,
  class: "qrcode"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-Iconawesome-donate" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "drop"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-Iconmaterial-get-app" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-guankancishu" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-lujing133" }, null, -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "info info1"
}
const _hoisted_27 = { class: "filter" }
const _hoisted_28 = { class: "desc" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "comments" }
const _hoisted_31 = { class: "list" }
const _hoisted_32 = { class: "item c-border" }
const _hoisted_33 = { class: "avatar" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "item-info" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = { class: "space line1" }
const _hoisted_38 = { class: "c-thirdary" }
const _hoisted_39 = { class: "content" }
const _hoisted_40 = { class: "write" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = {
  key: 1,
  class: "info info2"
}
const _hoisted_43 = { class: "th item" }
const _hoisted_44 = { class: "line1" }
const _hoisted_45 = {
  key: 0,
  class: "icon i-bofang"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "not-found c-secondary"
}

import devices from '@/store/device';
import api from '@/api/fyApi';
import backMusic from '@/store/backMusic';
import room, { State } from '@/store/channels/live';
import * as filters from '@/views/filters';
import * as links from '@/views/links';
import ViewContext from '@/views/ViewContext';
import { computed, inject, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';
import fy2Api from '@/api/fy2Api';
import userApi from '@/api/userApi';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext
const store = useStore()
const data = computed<State>(() => store.state[room.name])
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].live)
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)

const state = reactive({
    qrVisible: false,
    leftTime: -1,
    onlineCount: 0,
    timer: 0,
    timeIndex: -1,
    good: false,
    movid: '',
    urlid: '',
    filter: 0,
    comment: '',
    loading: false,
})
const player = ref<any>()
const scroller = ref<HTMLDivElement>()

onMounted(() => {
    onCheck()
    onIdChange()
    //@ts-ignore
    state.timer = setInterval(onTimer, 1000)
    backMusic.shutdown(store)
})
onBeforeUnmount(function () {
    clearInterval(state.timer)
    if (player.value) {
        context.dispostAliPlayer('video', player.value)
    }
    clearInterval(chatTimer)
    if (chatWS) {
        //@ts-ignore
        chatWS.retry = false
        chatWS.close()
    }
})

watch(() => data.value.live, onCheck)
watch(() => data.value.id, onIdChange)

let chatWS: WebSocket
let chatTimer: any = 0

function createChatWebsocket() {
    if (chatWS) {
        //@ts-ignore
        chatWS.retry = false
        chatWS.close()
        clearInterval(chatTimer)
    }
    let chat = new WebSocket('wss://ws-live.sanmanuela.net/yqk')
    //@ts-ignore
    chat.retry = true
    chatTimer = setInterval(() => {
        console.info('pong')
        chat.send('{"type":"pong"}')
    }, 50000)
    chat.onmessage = function (e: MessageEvent) {
        console.info('<<<', e.data)
        try {
            let msg = JSON.parse(e.data)
            switch (msg.type) {
                case 'ping':
                    break
                case 'online':
                    state.onlineCount = msg.online_count
                    break
                case 'not_publish':
                case 'publish':
                case 'publish_done':
                case 'playback':
                    if (player.value) {
                        context.dispostAliPlayer('video', player.value)
                        player.value = null
                    }
                    setTimeout(() => {
                        if (data.value.live) {
                            console.info('----', msg.room)
                            room.update(store, msg.room)
                        }
                    }, msg.delay * 1000 + 2000)

                    break
                default:
                    console.info('unknow', e.data)
                    break
            }
        } catch (err) {
            console.info('unknow', e.data)
        }
    }
    chat.onopen = function () {
        chat.send(JSON.stringify({ type: 'login', room_id: data.value.id }))
    }
    chat.onclose = function () {
        //@ts-ignore
        console.info('-chat close', chat.retry)
        //@ts-ignore
        if (chat.retry) {
            setTimeout(createChatWebsocket, 3000)
        }
    }
    chat.onerror = function () {
        //@ts-ignore
        console.info('-chat error', chat.retry)
        chat.close()
        //@ts-ignore
        if (chat.retry) {
            //@ts-ignore
            chat.retry = false
            setTimeout(createChatWebsocket, 3000)
        }
    }
    chatWS = chat
}

function onIdChange() {
    createChatWebsocket()
}

function onCheck() {
    if (data.value.live) {
        state.good = false
        let goods = localStorage.getItem('live-goods')
        if (goods) {
            try {
                let map = JSON.parse(goods)
                state.good = !!map[data.value.live.id]
            } catch (e) {
            }
        }
        state.onlineCount = data.value.live.online
        state.leftTime = -1
        if (data.value.live.push_status == 0) {
            let offset = Math.floor(data.value.live.starttime - Date.now() / 1000)
            if (offset < 3600 * 24) {
                state.leftTime = offset
            }
        } else if (data.value.live.push_status == 1) {
            const url = data.value.live.play_url
            setTimeout(() => {
                createPlayer(url, true)
            }, 20)
        } else if (data.value.live.push_status == 3) {
            if (data.value.live.player_type == 0) {
                const url = data.value.live.playback_url
                setTimeout(() => {
                    createPlayer(url, false)
                }, 20)
            } else {
                data.value.live.push_status = 4
                let ids = data.value.live.playback_urlid.split('-')
                state.movid = ids[0]
                state.urlid = ids[1]
            }
        }
        onTypeChange(state.filter)
    }
}

function onTimer() {
    if (data.value.live) {
        if (state.leftTime > 0 && data.value.live.push_status == 0) {
            let offset = Math.floor(data.value.live.starttime - Date.now() / 1000)
            if (offset < 3600 * 24) {
                state.leftTime = offset
                if (offset <= 0) {
                    room.reload(store, data.value.live.id)
                    return
                }
            } else {
                state.leftTime = -1
            }
        }
        if (scroller.value) {
            let dt = new Date()
            let hours = dt.getHours()
            let minutes = dt.getMinutes()
            let time = hours * 100 + minutes
            let i = data.value.live.item_json.findIndex(item => item.time > time)
            if (i < 0) {
                i = data.value.live.item_json.length - 1
            } else {
                i--
            }
            if (i >= 0 && state.timeIndex != i) {
                state.timeIndex = i
                scroller.value.scrollTop = i * 30
            }
        }
    }
}

function createPlayer(source: string, isLive: boolean) {
    context.dispostAliPlayer('video', player.value)
    player.value = context.createAliPlayer('video', source, function () {
        //@ts-ignore
    }, { isLive, auto: !window.isMac, poster: '', rate: !isLive })
}

function onShowQr() {
    state.qrVisible = true
    document.onmousedown = function () {
        document.onmousedown = null
        state.qrVisible = false
    }
}

async function onVote() {
    if (state.good) {
        return
    }
    if (data.value.live) {
        state.good = !state.good
        let id = data.value.live.id
        await api.postVote(id)
        data.value.live.agree++
        let goods = localStorage.getItem('live-goods')
        if (goods) {
            try {
                let map = JSON.parse(goods)
                map[id] = 1
                localStorage.setItem('live-goods', JSON.stringify(map))
            } catch (e) {
            }
        } else {
            localStorage.setItem('live-goods', JSON.stringify({ [id]: 1 }))
        }
    }
}

function onTypeChange(value: number) {
    state.filter = value
    if (value == 1) {
        loadComments()
    }
}

const comments = ref<any[]>([])
async function loadComments() {
    let { list } = await fy2Api.getLiveComments(data.value.id)
    comments.value = list
}

async function onSubmitComment() {
    let text = state.comment.trim()
    if (!text) {
        return
    }
    if (state.loading) {
        return
    }
    try {
        state.loading = true
        let r = await userApi.submitLiveComment(data.value.id, text)
        devices.toast(store, r.msg)
        state.comment = ''
    } finally {
        state.loading = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(data).live)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              class: "video",
              style: _normalizeStyle(_unref(filters).bg(_unref(data).live.thumb))
            }, [
              (_unref(data).live.push_status == 1 || _unref(data).live.push_status == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, null, 512))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_unref(data).live.push_status == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", null, _toDisplayString(_unref(i18).format(_unref(lang).liveIsStart, _unref(filters).datetime(_unref(data).live.starttime))), 1),
                          (_unref(state).leftTime >= 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(filters).leftTime(_unref(state).leftTime)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_unref(data).live.push_status == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(lang).liveIsEnd), 1))
                        : (_unref(data).live.push_status == 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createTextVNode(_toDisplayString(_unref(lang).liveIsEnd) + " ", 1),
                              _hoisted_11,
                              _createVNode(_component_router_link, {
                                to: _unref(links).player(_unref(state).movid, _unref(state).urlid)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(lang).clickToReplay), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true)
                  ]))
            ], 4),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, [
                _hoisted_13,
                _createElementVNode("span", null, _toDisplayString(_unref(lang).online) + ": " + _toDisplayString(_unref(filters).unit(_unref(state).onlineCount)), 1)
              ]),
              _createElementVNode("span", _hoisted_14, [
                (_unref(data).live.donate_qrcode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createElementVNode("a", {
                        class: _normalizeClass({ on: _unref(state).qrVisible }),
                        onClick: onShowQr
                      }, [
                        _hoisted_16,
                        _createTextVNode(_toDisplayString(_unref(lang).sponsor), 1)
                      ], 2),
                      (_unref(state).qrVisible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("img", {
                              src: _unref(data).live.donate_qrcode
                            }, null, 8, _hoisted_18)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(data).live.attachment)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createElementVNode("a", {
                        href: _unref(data).live.attachment,
                        target: "_blank"
                      }, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_unref(lang).download), 1)
                      ], 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                  _hoisted_22,
                  _createElementVNode("span", null, _toDisplayString(_unref(filters).unit(_unref(data).live.hits)), 1)
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    class: _normalizeClass({ on: _unref(state).good }),
                    onClick: onVote
                  }, [
                    _hoisted_23,
                    (_unref(state).good)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(filters).unit(_unref(data).live.agree)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(lang).good), 1))
                  ], 2)
                ])
              ])
            ])
          ]),
          (_unref(data).live.item_status == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: _unref(state).filter === 0 }),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onTypeChange(0)))
                  }, _toDisplayString(_unref(lang).intro), 3),
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: _unref(state).filter === 1 }),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onTypeChange(1)))
                  }, _toDisplayString(_unref(lang).comments), 3)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", {
                    innerHTML: _unref(data).live.content
                  }, null, 8, _hoisted_29)
                ], 512), [
                  [_vShow, _unref(state).filter === 0]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("img", {
                            src: item.user.avatar_url
                          }, null, 8, _hoisted_34)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(item.user.nickname), 1),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(filters).datetime(item.createtime)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(item.content), 1)
                        ])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "c-primary",
                      placeholder: _unref(channelLang).comment,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).comment) = $event)),
                      maxlength: "200"
                    }, null, 8, _hoisted_41), [
                      [_vModelText, _unref(state).comment]
                    ]),
                    _createElementVNode("a", { onClick: onSubmitComment }, _toDisplayString(_unref(channelLang).submit), 1)
                  ])
                ], 512), [
                  [_vShow, _unref(state).filter === 1]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).time), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).content), 1)
                ]),
                _createElementVNode("div", {
                  class: "list",
                  ref_key: "scroller",
                  ref: scroller
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).live.item_json, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item", { on: i == _unref(state).timeIndex }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.key), 1),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(item.value), 1),
                      (i == _unref(state).timeIndex)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 256))
                ], 512)
              ])),
          _hoisted_46
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_unref(lang).empty), 1))
  ]))
}
}

})